export const applyUiInteractions = (controller) => {
  Object.assign(controller, {
    showLoader(loader) {
      loader.classList.add("media__loader--visible");
    },

    hideLoader(loader) {
      loader.classList.remove("media__loader--visible");
    },

    goForward(curr, next) {
      curr.classList.remove("media__slide--active");
      next.classList.add("media__slide--active");
    },

    goBack(curr, prev) {
      curr.classList.remove("media__slide--active");
      prev.classList.add("media__slide--active");
    },

    next(e) {
      e.preventDefault();
      this.clearSelectedImage(this.cropperImageContainer);
      this.showLoader(this.loaderTarget);
      this.imageUrlToBase64();
    },

    async openCropper(e, image_url, cropper_data, image_name, zoom) {
      e.preventDefault();
      this.clearSelectedImage(this.cropperImageContainer);

      const loaderEl = this.cropSectionTarget?.querySelector?.('.media__loader');
      if (loaderEl) this.showLoader(loaderEl);

      if (this.fromSiteBuilderValue) {
        this.filenameTarget.textContent = image_name;
      }
  
      const base64data = await this.urlToBase64Store(image_url);
  
      try {
        await this.setupImageForCropping(
          this.cropperImageContainer,
          base64data
        );
        this.mediaSelectCropper = this.initializeLogoCropper(
          this.cropperSection,
          cropper_data
        );
        const imageCropper = this.mediaSelectCropper;
        const cropperInstance = imageCropper.cropper;
        this.fileUploadCropper = imageCropper;
        const self = this;
        cropperInstance.element.addEventListener('ready', function onReady() {
          cropperInstance.zoomTo(zoom);
          if (loaderEl) self.hideLoader(loaderEl);
          cropperInstance.element.removeEventListener('ready', onReady);
        });
        return base64data;
      } catch (error) {
        console.error('Failed to open cropper:', error);
        return;
      }  
    }
  });
};
